module.exports = __webpack_public_path__ + "img/logo-regular.fb43759d.gif";